import {ErrorHandler} from '@angular/core';
import {Notifier} from '@airbrake/browser';

export class AirbrakeErrorHandler implements ErrorHandler {
  airbrake: Notifier;

  constructor() {
    this.airbrake = new Notifier({
      projectId: 526264,
      projectKey: '5fbce12c969cbe1fd0486098d0568b1e',
      environment: 'production',
    });
  }

  handleError(error: any) {
    void this.airbrake.notify(JSON.stringify(error));
  }
}
